import React, { useEffect, useState } from "react";
import "./App.css";
import heroImage from "./assets/oloyefxpic.jpg";

function App() {
  const [navbarShrink, setNavbarShrink] = useState(false);
  const [activeSection, setActiveSection] = useState("home");

  // Risk Calculator states
  const [balance, setBalance] = useState(1000);
  const [riskPercent, setRiskPercent] = useState(1);
  const [stopLoss, setStopLoss] = useState(50);
  const [lotSize, setLotSize] = useState(null);
  const [rewardRiskRatio, setRewardRiskRatio] = useState(2);
  const [asset, setAsset] = useState("forex");

  const calculateLot = () => {
    if (!balance || !riskPercent || !stopLoss) return;
    const riskAmount = (balance * riskPercent) / 100;
    const lot = riskAmount / stopLoss; // simple formula for demo
    setLotSize(lot);
  };

  useEffect(() => {
    const handleScroll = () => {
      setNavbarShrink(window.scrollY > 50);
      const sections = [
        "home",
        "about",
        "services",
        "charts",
        "blog",
        "contact",
      ];
      let current = "home";
      sections.forEach((id) => {
        const section = document.getElementById(id);
        if (section && window.scrollY >= section.offsetTop - 200) current = id;
      });
      setActiveSection(current);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (e, id) => {
    e.preventDefault();
    const target = document.getElementById(id);
    if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://s3.tradingview.com/tv.js";
    script.async = true;
    document.body.appendChild(script);
    return () => document.body.removeChild(script);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (window.TradingView) {
        new window.TradingView.widget({
          width: "100%",
          height: 300,
          symbol: "OANDA:XAUUSD",
          interval: "15",
          timezone: "Etc/UTC",
          theme: "dark",
          style: "1",
          locale: "en",
          hide_top_toolbar: false,
          hide_legend: false,
          save_image: false,
          container_id: "tv-xauusd",
        });
        new window.TradingView.widget({
          width: "100%",
          height: 300,
          symbol: "BINANCE:BTCUSDT",
          interval: "15",
          timezone: "Etc/UTC",
          theme: "dark",
          style: "1",
          locale: "en",
          hide_top_toolbar: false,
          hide_legend: false,
          save_image: false,
          container_id: "tv-btcusd",
        });
        clearInterval(interval);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="font-sans bg-black text-white scroll-smooth">
      {/* Navbar */}
      <nav
        className={`fixed w-full z-50 backdrop-blur-sm transition-all duration-300 ${
          navbarShrink
            ? "py-2 shadow-lg bg-[#b87333]/95"
            : "py-5 bg-[#b87333]/90"
        }`}
      >
        <div className="max-w-7xl mx-auto flex justify-between items-center px-5">
          <div className="text-2xl md:text-3xl font-bold text-white tracking-wider drop-shadow-lg">
            OLOYE fx
          </div>
          <ul className="flex space-x-6 text-white font-medium">
            {["home", "about", "services", "charts", "blog", "contact"].map(
              (section) => (
                <li key={section}>
                  <a
                    href={`#${section}`}
                    onClick={(e) => handleNavClick(e, section)}
                    className={`relative transition-all duration-500 ease-in-out py-1 px-3 rounded ${
                      activeSection === section
                        ? "text-black bg-white/90 shadow-md glow-link"
                        : "hover:text-black hover:bg-white/30"
                    }`}
                  >
                    {section.charAt(0).toUpperCase() + section.slice(1)}
                  </a>
                </li>
              )
            )}
          </ul>
        </div>
      </nav>

      {/* Hero Section */}
      <section
        id="home"
        className="relative h-screen bg-cover bg-center flex items-center justify-center hero-zoom"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <div className="absolute inset-0 bg-black/40"></div>
        <div className="relative text-center text-white px-5">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 glow-copper">
            OLOYE fx Trading & Investment Group
          </h1>
          <p className="text-xl md:text-2xl mb-6 max-w-2xl mx-auto">
            Expert trading, verified signals, and professional investment
            management.
          </p>
          <div className="flex justify-center space-x-4">
            <a
              href="mailto:soliukazeemoloyede@gmail.com"
              className="border border-[#b87333] text-[#b87333] px-6 py-3 rounded hover:bg-[#b87333] hover:text-white transition glow-hover"
            >
              Contact Me
            </a>
            <a
              href="https://t.me/OLOYEsTradingchannel"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#b87333] text-white px-6 py-3 rounded hover:bg-[#d4893d] transition glow-hover"
            >
              Join Telegram
            </a>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-24 px-5 text-center bg-black">
        <h2 className="text-4xl font-bold mb-6 text-[#d4893d]">About Me</h2>
        <p className="text-lg max-w-3xl mx-auto text-gray-300 leading-relaxed">
          Hi, I’m <strong>Soliu Kazeem Oloyede</strong>, founder of{" "}
          <strong>OLOYE fx Trading & Investment Group</strong>. I specialize
          in Forex, Crypto, and Indices trading — combining technical and
          fundamental analysis to achieve consistent profitability. I help
          traders grow through mentorship, signals, and account management.
        </p>
      </section>

      {/* Services Section */}
      <section id="services" className="py-24 px-5 text-center bg-black">
        <h2 className="text-4xl font-bold mb-12 text-[#d4893d]">Services</h2>
        <div className="max-w-6xl mx-auto grid md:grid-cols-3 gap-8">
          {[
            {
              title: "Trade Signals",
              text: "Receive accurate daily trading signals for Forex, Crypto, and Indices.",
            },
            {
              title: "Account Management",
              text: "Let me trade for you using verified strategies with transparent performance.",
            },
            {
              title: "Trading Education",
              text: "Learn professional trading skills through one-on-one mentorship and online tutorials.",
            },
          ].map((service) => (
            <div
              key={service.title}
              className="bg-[#111]/80 p-6 rounded shadow hover:shadow-[#b87333] transition"
            >
              <h3 className="text-2xl font-semibold mb-4 text-[#b87333]">
                {service.title}
              </h3>
              <p className="text-gray-300">{service.text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Live Market Charts Section */}
      <section id="charts" className="py-24 px-5 text-center bg-black">
        <h2 className="text-4xl font-bold mb-12 text-[#d4893d]">
          Live Market Charts
        </h2>
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-10">
          <div className="bg-[#111]/80 rounded-2xl p-5 shadow-lg border border-[#b87333]/40">
            <h3 className="text-2xl font-semibold mb-4 text-[#b87333]">
              XAUUSD (Gold)
            </h3>
            <div
              id="tv-xauusd"
              className="rounded-lg overflow-hidden shadow-inner border border-[#b87333]/20"
              style={{ height: 300 }}
            ></div>
          </div>
          <div className="bg-[#111]/80 rounded-2xl p-5 shadow-lg border border-[#b87333]/40">
            <h3 className="text-2xl font-semibold mb-4 text-[#b87333]">
              BTCUSDT (Bitcoin)
            </h3>
            <div
              id="tv-btcusd"
              className="rounded-lg overflow-hidden shadow-inner border border-[#b87333]/20"
              style={{ height: 300 }}
            ></div>
          </div>
        </div>

        {/* Lot Size, Trading Sessions, Risk Calculator */}
        <div className="max-w-7xl mx-auto mt-6 grid md:grid-cols-3 gap-6">

          {/* Lot Size Options */}
          <div className="bg-[#111]/80 rounded-2xl p-4 shadow hover:shadow-[#b87333] transition text-gray-300 text-sm">
            <h3 className="text-xl font-semibold mb-2 text-[#b87333]">Lot Size Options</h3>
            <p className="mb-2 text-gray-400">
              Understanding lot sizes is key to managing your risk in trading. Here’s a guide to help you choose the right lot size based on your account balance.
            </p>
            <div className="space-y-2 text-gray-300 text-sm">
              <div><strong>$10 - $50</strong><br />🔴 High Risk: 0.03<br />🟡 Mid Risk: 0.02<br />🟢 Low Risk: 0.01</div>
              <div><strong>$51 - $100</strong><br />🔴 High Risk: 0.05<br />🟡 Mid Risk: 0.02<br />🟢 Low Risk: 0.01</div>
              <div><strong>$101 - $200</strong><br />🔴 High Risk: 0.10<br />🟡 Mid Risk: 0.05<br />🟢 Low Risk: 0.02</div>
              <div><strong>$201 - $500</strong><br />🔴 High Risk: 0.25<br />🟡 Mid Risk: 0.10<br />🟢 Low Risk: 0.05</div>
              <div><strong>$501 - $1,000</strong><br />🔴 High Risk: 0.50<br />🟡 Mid Risk: 0.25<br />🟢 Low Risk: 0.10</div>
              <div><strong>$1,001 - $5,000</strong><br />🔴 High Risk: 1.0<br />🟡 Mid Risk: 0.5<br />🟢 Low Risk: 0.2</div>
            </div>
          </div>

          {/* Trading Sessions */}
          <div className="bg-[#111]/80 rounded-2xl p-4 shadow hover:shadow-[#b87333] transition text-center">
            <h3 className="text-xl font-semibold mb-2 text-[#b87333]">Trading Sessions</h3>
            <p className="mb-4 text-gray-400">
              Visual guide for the Forex trading sessions to help you trade at the right times.
            </p>
            <img
              src={require("./assets/alerms.jpg")}
              alt="Trading Sessions"
              className="mx-auto rounded shadow-lg w-full md:w-80 filter brightness-90 contrast-110"
            />
          </div>

          {/* Risk Calculator */}
          <div className="bg-[#111]/80 rounded-2xl p-6 shadow hover:shadow-[#b87333] transition text-gray-300 text-center">
            <h3 className="text-xl font-semibold mb-4 text-[#b87333]">Risk Calculator</h3>
            <p className="mb-4 text-gray-400">
              Calculate the ideal lot size based on your account balance, risk %, stop loss, and reward ratio.
            </p>

            <div className="max-w-sm mx-auto space-y-3 text-left">
              <div>
                <label className="block mb-1">Trading Instrument</label>
                <select
                  value={asset}
                  onChange={(e) => setAsset(e.target.value)}
                  className="w-full p-2 rounded bg-[#111]/80 text-white border border-gray-600"
                >
                  <option value="forex">Forex (GBPUSD)</option>
                  <option value="gold">XAUUSD (Gold)</option>
                  <option value="crypto">BTCUSD (Crypto)</option>
                </select>
              </div>

              <div>
                <label className="block mb-1">Account Balance ($)</label>
                <input
                  type="number"
                  value={balance}
                  onChange={(e) => setBalance(e.target.value)}
                  className="w-full p-2 rounded bg-[#111]/80 text-white border border-gray-600"
                />
              </div>

              <div>
                <label className="block mb-1">Risk Percentage (%)</label>
                <input
                  type="number"
                  value={riskPercent}
                  onChange={(e) => setRiskPercent(e.target.value)}
                  className="w-full p-2 rounded bg-[#111]/80 text-white border border-gray-600"
                />
              </div>

              <div>
                <label className="block mb-1">Stop Loss (pips/points)</label>
                <input
                  type="number"
                  value={stopLoss}
                  onChange={(e) => setStopLoss(e.target.value)}
                  className="w-full p-2 rounded bg-[#111]/80 text-white border border-gray-600"
                />
              </div>

              <div>
                <label className="block mb-1">Reward:Risk Ratio</label>
                <input
                  type="number"
                  value={rewardRiskRatio}
                  onChange={(e) => setRewardRiskRatio(e.target.value)}
                  className="w-full p-2 rounded bg-[#111]/80 text-white border border-gray-600"
                />
              </div>

              <button
                onClick={calculateLot}
                className="w-full bg-[#b87333] text-white py-2 rounded hover:bg-[#d4893d] transition mt-2"
              >
                Calculate Lot Size
              </button>

              {lotSize !== null && (
                <div className="mt-3 space-y-1 text-green-400 font-semibold">
                  <p>Suggested Lot Size: {lotSize.toFixed(2)} lots</p>
                  <p>Dollar Risk: ${(balance * (riskPercent / 100)).toFixed(2)}</p>
                  <p>Potential Profit (at {rewardRiskRatio}:1): ${(balance * (riskPercent / 100) * rewardRiskRatio).toFixed(2)}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Blog Section */}
      <section id="blog" className="py-24 px-5 text-center bg-black">
        <h2 className="text-4xl font-bold mb-12 text-[#d4893d]">
          Blog & Education
        </h2>
        <div className="max-w-4xl mx-auto space-y-6">
          <div className="bg-[#111]/80 p-6 rounded shadow hover:shadow-[#b87333] transition">
            <h3 className="text-2xl font-semibold mb-2 text-[#b87333]">
              Mastering Forex Day Trading
            </h3>
            <p className="text-gray-300">
              Key mindset shifts and techniques to achieve consistent intraday
              profits.
            </p>
          </div>
          <div className="bg-[#111]/80 p-6 rounded shadow hover:shadow-[#b87333] transition">
            <h3 className="text-2xl font-semibold mb-2 text-[#b87333]">
              Crypto Market Psychology
            </h3>
            <p className="text-gray-300">
              Understanding trader emotion and timing in volatile markets.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-24 px-5 text-center bg-black">
        <h2 className="text-4xl font-bold mb-6 text-[#d4893d]">Contact Me</h2>
        <p className="text-gray-300 mb-6">
          Reach out via Telegram, WhatsApp, Email, or my social platforms below.
        </p>

        <div className="flex justify-center gap-6 mb-12 flex-wrap">
          <a
            href="https://t.me/OLOYEsTradingchannel"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#b87333] text-white px-5 py-3 rounded hover:bg-[#d4893d] transition glow-hover"
          >
            Telegram
          </a>
          <a
            href="mailto:soliukazeemoloyede@gmail.com"
            className="bg-[#b87333] text-white px-5 py-3 rounded hover:bg-[#d4893d] transition glow-hover"
          >
            Email
          </a>
          <a
            href="https://wa.me/2348131857808"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#b87333] text-white px-5 py-3 rounded hover:bg-[#d4893d] transition glow-hover"
          >
            WhatsApp
          </a>
          <a
            href="https://www.youtube.com/@OLOYE-TRADING-CHANNEL"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#b87333] text-white px-5 py-3 rounded hover:bg-[#d4893d] transition glow-hover"
          >
            YouTube
          </a>
          <a
            href="https://www.myfxbook.com/members/OLOYEDE"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#b87333] text-white px-5 py-3 rounded hover:bg-[#d4893d] transition glow-hover"
          >
            Myfxbook
          </a>
        </div>

        <form
  name="contact"
  method="POST"
  data-netlify="true"
  action="/success"
  className="max-w-md mx-auto space-y-4 bg-[#111]/60 p-6 rounded-lg shadow-lg"
>
  <input type="hidden" name="form-name" value="contact" />
  <p>
    <label>Your Name <input type="text" name="name" required /></label>
  </p>
  <p>
    <label>Your Email <input type="email" name="email" required /></label>
  </p>
  <p>
    <label>Your Message <textarea name="message" required></textarea></label>
  </p>
  <p>
    <button
      type="submit"
      className="bg-[#b87333] text-white px-4 py-2 rounded-lg hover:bg-[#d98f4e] transition"
    >
      Send Message
    </button>
  </p>
</form>
      </section>

      {/* Footer */}
      <footer className="bg-[#b87333] text-white py-6 text-center">
        <p>
          &copy; 2025 OLOYE fx Trading & Investment Group. All rights reserved.
        </p>
        <div className="mt-2 flex justify-center space-x-4">
          <a
            href="https://t.me/OLOYEsTradingchannel"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[#d4893d]"
          >
            Telegram
          </a>
          <a
            href="mailto:soliukazeemoloyede@gmail.com"
            className="hover:text-[#d4893d]"
          >
            Email
          </a>
          <a
            href="https://www.myfxbook.com/members/OLOYEDE"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[#d4893d]"
          >
            Myfxbook
          </a>
        </div>
      </footer>
    </div>
  );
}

export default App;
